import { Entry } from 'contentful';
import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import IOfferBSlideData from '@app/types/data/slides/IOfferBSlideData';
import AbstractOfferSlideTransform from '@app/transforms/slides/AbstractOfferSlideTransform';
import IMenuItem from '@app/types/data/base/IMenuItem';
import IPresentationSettings from '@app/types/presentations/presentation/IPresentationSettings';
import IImage from '@app/types/data/base/IImage';

export default class OfferBSlideTransform extends AbstractOfferSlideTransform {
	public viewComponent: string = 'OfferBSlide';

	public async transform(slide: ISlideMaster, presentationSettings: IPresentationSettings): Promise<IOfferBSlideData> {
		const list: IMenuItem[] = [];

		if (slide.fields.list) {
			list.push(
				...slide.fields.list.map(
					(item: Entry<any>): IMenuItem => {
						let images: IImage[] | undefined;

						if (item.fields.images) {
							images = (item.fields.images as Entry[]).map((media) =>
								this.transformImageAsset(media.fields.asset as any, {
										width: 265, // eslint-disable-line
										height: 150, // eslint-disable-line
										crop: 'limit' // eslint-disable-line
								})
							);
						}

						return {
							title: item.fields.title as IMenuItem['title'],
							description: item.fields.description as IMenuItem['description'],
							bookingCode: item.fields.bookingCode as IMenuItem['bookingCode'] || undefined,
							price: item.fields.price as IMenuItem['price'] || undefined,
							images
						};
					}
				)
			);
		}

		const data: IOfferBSlideData = {
			...(await super.transform(slide, presentationSettings)),
			type: slide.fields.type || undefined,
			listHeadline: slide.fields.listHeadline,
			list,
			additionalInformation: this.transformRichtext(slide.fields.additionalInformation, presentationSettings)
		};

		return data;
	}
}
